
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.41 15.707c.437.39 1.148.39 1.585 0l4.478-4a.928.928 0 000-1.416 1.218 1.218 0 00-1.585 0L9.32 12.585V1c0-.553-.5-1-1.12-1-.618 0-1.119.447-1.119 1v11.585l-2.567-2.294a1.218 1.218 0 00-1.585 0 .928.928 0 000 1.416l4.478 4h.003z","fill":"#313131"}})])
          )
        }
      }
    